import { traverseTree } from '../../../utils/traverseTree';
import {
  changeSubTreeKeyVisitor,
  addArtifactIdVisitor,
  addUrlFormatVisitor,
  createGuideFromIndexPageDescriptionVisitor,
  addGuidesToNodesVisitor,
  markMainEntitiesVisitor,
  updateEventsStructure,
  createTagsSubTreesVisitor,
  markCallbacksVisitor,
  addOriginalPathVisitor,
  nodeMixingEnricherVisitor,
  removeFlyntCommentsVisitor,
} from '../../../utils/treeVisitors';

export function applyTreeVisitors(docsTree, extraVisitors = []) {
  traverseTree(docsTree, [changeSubTreeKeyVisitor]);
  traverseTree(docsTree, [
    nodeMixingEnricherVisitor(docsTree),
    updateEventsStructure,
    addUrlFormatVisitor,
    createGuideFromIndexPageDescriptionVisitor,
    createTagsSubTreesVisitor,
    markMainEntitiesVisitor,
    addGuidesToNodesVisitor,
    addArtifactIdVisitor,
    markCallbacksVisitor(docsTree),
    addOriginalPathVisitor,
    removeFlyntCommentsVisitor,
    ...extraVisitors,
  ]);
}
